<span class="typing-message_random">{{ randomText }}</span>